<template>
  <div
    class="rounded-md p-16 flex flex-col gap-8 md:items-center md:flex-row md:p-24 lg:p-48"
    :class="backgroundClass ?? 'bg-surface-tertiary'"
  >
    <div class="flex flex-col gap-8">
      <p v-if="title" class="heading-xs">{{ title }}</p>
      <p v-if="text">{{ text }}</p>
    </div>
    <div
      v-if="linkButtonText && linkButtonUrl"
      class="w-full md:ml-auto md:w-fit"
    >
      <AppButton
        color="primary"
        size="default"
        :href="linkButtonUrl"
        full-width
      >
        {{ linkButtonText }}
      </AppButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  backgroundClass?: string;
  title?: string;
  text?: string;
  linkButtonText?: string;
  linkButtonUrl?: string;
}
defineProps<Props>();
</script>

<style scoped></style>
